import React, { Component } from "react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Creators as ReportsActions } from "store/ducks/reports";
import {
  Creators as StoresActions,
  Selectors as StoresSelectors,
} from "store/ducks/stores";

import { Form } from "components";

class Filters extends Component {
  state = {
    status: [
      { value: "solved", label: "Resolvido" },
      { value: "open", label: "Aberto" },
      { value: "closed", label: "Encerrado" },
    ],
  };

  render() {
    const { status } = this.state;
    const { data, onChange, onClean } = this.props;

    return (
      <Form className="row form-filters">
        <Form.Field className="col-md-3">
          <Form.Label>Status</Form.Label>
          <Form.Select
            placeholder="Status"
            value={data.status}
            options={status}
            onChange={(value) => onChange("status", value)}
          />
        </Form.Field>

        <Form.Field className="col-md-2">
          <Form.Label>Período, de</Form.Label>
          <Form.Icon name="calendar">
            <Form.DatePicker
              dateFormat="dd/MM/yyyy"
              selected={data.date_start}
              onChange={(value) => onChange("date_start", value)}
            />
          </Form.Icon>
        </Form.Field>

        <Form.Field className="col-md-2">
          <Form.Label>Período, até</Form.Label>
          <Form.Icon name="calendar">
            <Form.DatePicker
              dateFormat="dd/MM/yyyy"
              selected={data.date_end}
              onChange={(value) => onChange("date_end", value)}
              minDate={data.date_start}
              disabled={data.date_start === null}
            />
          </Form.Icon>
        </Form.Field>

        <Form.Field className="col-md-2">
          <Form.Button className="button-clean-filter" onClick={onClean}>
            Resetar Filtro
          </Form.Button>
        </Form.Field>
      </Form>
    );
  }
}

const mapstate = (state) => ({
  reports: state.reports,
  stores: {
    ...state.stores,
    data: StoresSelectors.options(state.stores.data),
  },
});

const mapActions = (dispatch) =>
  bindActionCreators({ ...ReportsActions, ...StoresActions }, dispatch);

export default connect(mapstate, mapActions)(Filters);
